// 基础信息
export const baseInfoColumns = [
  { label: "所在行", prop: "placeRowName", minWidth: "60", align: 'center' },
  { label: "用户ID", prop: "userId", minWidth: "80", align: 'center' },
  { label: "姓名", prop: "userName", minWidth: "80", align: 'center' },
  { label: "手机号", prop: "userMobile", minWidth: "110", align: 'center' },
  { label: "系统中工作单位", prop: "oldDeptName", minWidth: "120", align: 'center',  },
  { label: "系统中基础信息", prop: "oldUserInfoDiff", minWidth: "180", align: 'center', showOverflowTooltip: true },
  { label: "表格中不匹配工作单位", prop: "newDeptName", minWidth: "120", align: 'center', showOverflowTooltip: true },
  { label: "表格中不匹配基础信息", prop: "newUserInfoDiff", minWidth: "180", align: 'center', showOverflowTooltip: true },
  { label: "更新状态", prop: "isUpdateStr", minWidth: "80", align: 'center' },
];
// 人员新增
export const userAddColumns = [
  { label: "所在行",  prop: "placeRowName", minWidth: "60", align: 'center' },
  { label: "用户ID", prop: "userId",  minWidth: "80", align: 'center' },
  { label: "姓名", prop: "userName", minWidth: "80", align: 'center' },
  { label: "工作单位", prop: "newDeptName", minWidth: "120", align: 'center' },
  { label: "单位及职务", prop: "newPosition", minWidth: "140", align: 'center' },
  { label: "出生年月", prop: "userBirthdayStr", minWidth: "100", align: 'center' },
  { label: "任现职时间",  prop: "currentPositionStratumTimeStr", minWidth: "100", align: 'center' },
  { label: "任现职务层次时间",  prop: "currentPositionTimeStr", minWidth: "100", align: 'center' },
  { label: "任现职级层次时间",  prop: "currentPositionLevelTimeStr", minWidth: "100", align: 'center' },
  { label: "职务层次", prop: "positionTagName",  minWidth: "100", align: 'center' },
  { label: "职级", prop: "positionLevelName", minWidth: "100", align: 'center' },
  { label: "干部级别", prop: "cadreLevelName", minWidth: "100", align: 'center' },
  { label: "关联状态", prop: "linkStatusName", minWidth: "100", align: 'center' },
];
// 其他集中培训
export const otherColumns = [
  { label: "所在行",  prop: "placeRowName", minWidth: "80", align: 'center' },
  { label: "用户ID", prop: "userId",  minWidth: "80", align: 'center' },
  { label: "姓名", prop: "userName", minWidth: "100", align: 'center' },
  { label: "手机号", prop: "userMobile", minWidth: "120", align: 'center', showOverflowTooltip: true },
  { label: "系统中工作单位", prop: "oldDeptName", minWidth: "160", align: 'center', showOverflowTooltip: true },
  { label: "系统中单位及职务", prop: "oldPosition", minWidth: "160", align: 'center', showOverflowTooltip: true },
  { label: "表格中工作单位", prop: "newDeptName", minWidth: "160", align: 'center', showOverflowTooltip: true },
  { label: "表格中单位及职务", prop: "newPosition", minWidth: "160", align: 'center', showOverflowTooltip: true },
  { label: "备注", prop: "matchRemark", minWidth: "160", align: 'center', showOverflowTooltip: true },
];
// 人员缺失
export const userMissingeColumns = [
  { label: "姓名", prop: "userName", align: 'center' },
  { label: "手机号", prop: "userMobile", align: 'center' },
  { label: "系统中工作单位", prop: "oldDeptName", align: 'center', showOverflowTooltip: true },
  { label: "系统中单位及职务", prop: "oldPosition", align: 'center', showOverflowTooltip: true },
];


export const tabTips = {
  '1' : "以下人员基础信息有调整，请确认是否更新人员基础信息。",
  '2' : "以下人员无法通过用户ID匹配，请进行人员新增或人员调动。",
  '3' : "以下人员存在其他异常情况，详见备注，请导出线下核对确认。",
  '4' : "以下人员在系统中存在但表格中缺失，请导出线下核对确认。",
}
